import React, { Component, Fragment } from "react";
import CaseTable from "../shared/CaseTable";
import CaseDetails from "../shared/CaseDetails";
import CaseActionPanel from "../shared/CaseActionPanel";
import CaseHistoryPanel from "../shared/CaseHistoryPanel";
import CaseLinkPanel from "../shared/CaseLinkPanel";
import CaseAPI from "../../api/CaseAPI";
import WebSocket from "../../api/WebSocket";
import CaseDetailsAPI from "../../api/CaseDetailsAPI";
import CaseAttachmentsAPI from "../../api/CaseAttachmentsAPI";
import CaseHistoryAPI from "../../api/CaseHistoryAPI";
import WorkflowAPI from "../../api/WorkflowAPI";
import AuthUtill from "../../utils/AuthUtil";
import { withTranslation } from "react-i18next";
import StateAPI from "../../api/StateAPI";
import _ from "lodash";
import { scroller } from "react-scroll";
import { CommonContext } from "../../context/CommonContext";
import CaseActionAPI from "../../api/CaseActionAPI";
import AuthUtil from "../../utils/AuthUtil";
import SockJsClient from 'react-stomp';
import ApiService from "../../auth/ApiService";
import Loading from "../shared/Loading";

const $ = window.$;

const SOCKET_URL = ApiService.API_URL + '/cng-websocket';

class CaseState extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props.params,
      columns: [],
      data: [],
      originalData: [],
      caseData: null,
      actions: [],
      action: null,
      loading: true,
      t: this.props.t,
      caseHistoryData: [],
      caseLinks: null,
      caseInfoPanelConfig: [],
      helpText: "",
      user: null,
      isPortalAdmin: false,
      caseTablechildKey: 0 
    };
  }

  static contextType = CommonContext

  reloadCaseTablechild = () => {
    this.setState(prevState => ({ caseTablechildKey: prevState.caseTablechildKey + 1 }));
  };

  componentDidMount() {
    const { workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId } = this.props.params;
    this.updateCaseTable(workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId);
    WebSocket.register([
      { route: "/topic/case", callback: this.refreshPageLockOnCaseLock }
    ]);
  }

  componentWillReceiveProps(nextProps) {
    const { workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId} = nextProps.params;
    this.updateCaseTable(workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId);
  }

  componentDidUpdate() {
    $('[data-toggle="tooltip"]').tooltip("hide");
  }


  updateCaseTable(workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId) {
    this.setState({ loading: true });

    this.clearShortcutFields();
    
    this.getStateActions(workflowId, caseStateId);
    CaseAPI.getColumns(workflowId, exerciseId, caseStateId, this.props.t).then(AllCaseData => {

      // Set initial state without columns - we'll set columns after filtering
      this.setState({
        data: [],
        originalData: [],
        caseState: caseState,
        workflowId,
        exerciseId,
        caseData: null,
        actions: actions,
        caseHistoryData: [],
        caseLinks: null,
        caseStateTitle: caseStateTitle
      });
      
      // Wait for filterColumns to complete before setting loading to false and updating page
      this.filterColumns().then(() => {
        // Column filtering completed successfully
        // No need to process the Promise
      }).catch(err => {
        console.log("Error in filterColumns:", err);
        // Only set fallback columns if filterColumns failed and didn't set any columns
        if (!this.state.columns || this.state.columns.length === 0) {
          this.setState({ columns: AllCaseData.columns });
        }
      }).finally(() => {
        this.updatePage();
        this.setState({loading:false});
      });

    }).catch(err => {
      console.log("Error Reading data " + err);
      this.setState({loading:false});
    });
  }

  getStateActions = (workflowId, caseStateId) => {

    StateAPI.getStateCaseActionInfo(workflowId, caseStateId)
      .then(data => {
        data.forEach((stateAction) => {
          if (stateAction.pinned === "true" && stateAction.type === "4") {
            this.setState({
              actionId: stateAction.id,
              actionLink: stateAction.workflowLink,
              shortcutIcon: stateAction.icon,
              isPinned: true,
              shortcutName: stateAction.title
            });
          }
        });
      })
      .catch(error => {
        console.log("Request failed", error);
      });
  }

  updatePage = () => {
    if (this.props.params.uniqueId != undefined && this.props.params.uniqueId != null) {
      var caseData = { "uniqueId": '' };
      caseData.uniqueId = this.props.params.uniqueId
      caseData.workflowId = this.props.params.workflowId
      this.onRowClick(caseData);
    }
  }

  onRowClick = caseData => {
    const { caseStateId, actions } = this.props.params

    CaseDetailsAPI.get(caseData.uniqueId)
        .then(caseData => {
          if (caseStateId !== undefined) {
            caseData.caseStateId = caseStateId;
          }
          this.setState({ caseData });
        })
        .catch(error => {
          console.log("Request failed", error);
          this.refreshPage();
        });

    Promise.all([
      this.updateCaseHistoryTable(caseData.uniqueId),
      this.getAllLinkedCaseData(caseData.uniqueId),
      this.getCaseInfoPanelConfig(caseData.workflowId, caseData.uniqueId),
      this.getCaseActionInfoConfig(caseData.workflowId, caseStateId, caseData.uniqueId),
      this.getCaseStateHelpText(caseStateId),
      this.setColumns(caseData.columns),
      this.getLoggedInUser(caseData.workflowId)
    ]).then(() => {
      scroller.scrollTo('case-info', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart'
      });
    });

  };

  getCaseStateHelpText = caseStateId => {
    StateAPI.getCaseStateHelpText(caseStateId)
      .then(textValue => this.setState({ helpText: textValue }))
  }

  setColumns = columns => {
    this.setState({
      columns: columns
    })
  }

  updateCaseHistoryTable = uniqueId => {
    CaseHistoryAPI.get(uniqueId)
      .then(caseHistory => {
        this.setState({
          caseHistoryData: caseHistory
        });
      })
      .catch(error => {
        console.log("Request failed", error);
        this.refreshPage();
      });
  }

  getAllLinkedCaseData = uniqueId => {
    this.setState({ caseLinks: null });
    CaseAPI.getAllLinkedCases(uniqueId).then(AllCaseData => {
      if (AllCaseData.length != 0) {
        this.setState({
          caseLinks: AllCaseData
        });
      }
    }).catch(error => {
      console.log("Request failed", error);
      this.refreshPage();
    });
  }

  getCaseInfoPanelConfig = (workflowId, caseUniqueId) => {
    WorkflowAPI.getCaseInfoConfigByWorkflowId(workflowId, caseUniqueId)
      .then(caseInfoConfig => {
        this.setState({
          caseInfoPanelConfig: caseInfoConfig
        });
      })
      .catch(error => {
        console.log("Request failed", error);
        this.refreshPage();
      });
  }

  getCaseActionInfoConfig = (workflowId, caseStateId, caseUniqueId) => {
    StateAPI.getCaseActionInfoConfig(workflowId, caseStateId, caseUniqueId)
      .then(data => this.setState({ actions: data }))
      .catch(error => {
        console.log("Request failed", error);
      });
  }

  isOldEntry = (caseDetail) => {
    var conditionalDate = new Date(2022, 9, 14, 0, 0, 0, 0);
    var submittedDate = new Date(caseDetail.auditInfo.createdDate);

    return submittedDate < conditionalDate;
  }

  onActionClick = (actionType, caseDetail, sendParams) => {
    const { t } = this.state
    var continuationURLProdEdited = caseDetail.continuationURL;

    if (this.isOldEntry(caseDetail) && caseDetail.continuationURL != null) {
      var externalCNGBaseURL = window.ENV.REACT_APP_CNG_EXTERNAL_BASE_URL;
      var DELIMITER = "workflowContinuation.action";
      var parts = caseDetail.continuationURL.split(DELIMITER);
      parts[0] = externalCNGBaseURL;
      continuationURLProdEdited = parts.join(DELIMITER);
    }

    console.log(">>>>>>>>>>>>>>>>>>>>>>" + continuationURLProdEdited);

    AuthUtill.getLoggedInUser().then(loggedInUser => {
      if (sendParams.type == '1') {
        switch (actionType) {
          case "LOCK":
            caseDetail.locked = true;
            this.updateCase(caseDetail, loggedInUser.uniqueId, sendParams);
            break;
          case "UNLOCK":
            caseDetail.locked = false;
            this.updateCase(caseDetail, loggedInUser.uniqueId, sendParams);
            this.refreshPage();
            break;
          case "VIEW_PDF":
            CaseAttachmentsAPI.getAttachmentByUrl(caseDetail.mainPdf.filePath, caseDetail.mainPdf.fileName);
            break;
          case "SEND_BACK":
            this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
            if (sendParams.isCaseHistoryEntry) {
              this.addCaseHistory(caseDetail, sendParams.caseHistoryEntryTitle, sendParams.comment);
            }
            break;
          case "REJECT":
            this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
            if (sendParams.isCaseHistoryEntry) {
              this.addCaseHistory(caseDetail, sendParams.caseHistoryEntryTitle, sendParams.comment);
            }
            break;
          case "APPROVED":
            this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
            if (sendParams.isCaseHistoryEntry) {
              this.addCaseHistory(caseDetail, sendParams.caseHistoryEntryTitle, sendParams.comment);
            }
            break;
          case "DELETE":
              this.addCaseHistory(caseDetail, "Case Deleted", "")
                  .then(() => {
                      this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
                  })
                  .catch(error => { 
                      console.error("Error saving case history:", error);
                  });
              break;
          case "ASSIGN":
            this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
            //this.refreshPage();
            break;
          case "LINK":
            this.updateCaseLinks(caseDetail, sendParams.records, loggedInUser.uniqueId, sendParams.successMessage);
            if (sendParams.isCaseHistoryEntry) {
              this.addCaseHistory(caseDetail, sendParams.caseHistoryEntryTitle, sendParams.comment);
            }
            //this.addCaseHistory(caseDetail, (sendParams.stateTransition+' to '+ sendParams.assignWorkerId), sendParams.comment);
            break;
          case "SET_GRADATION":
            this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
            //this.updateCaseLinks(caseDetail, sendParams.records, loggedInUserId);
            //this.addCaseHistory(caseDetail, (sendParams.stateTransition+' to '+ sendParams.assignWorkerId), sendParams.comment);
            this.refreshPage();
            break;
          case "ADD_INFO":
            this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
            //this.updateCaseLinks(caseDetail, sendParams.records, loggedInUserId);
            //this.addCaseHistory(caseDetail, (sendParams.stateTransition+' to '+ sendParams.assignWorkerId), sendParams.comment);
            this.refreshPage();
            break;
          case "ADD_COMMENT":
            if (sendParams.isCaseHistoryEntry) {
              this.addComment(caseDetail, sendParams.caseHistoryEntryTitle, sendParams.comment, true, sendParams.successMessage);
            }
            this.refreshPage();
            break;
          case "COMPLETE":
            this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
            this.refreshPage();
            break;
          case "RESTORE":
            this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
            if (sendParams.isCaseHistoryEntry) {
              this.addCaseHistory(caseDetail, sendParams.caseHistoryEntryTitle, sendParams.comment);
            }
            this.refreshPage();
            break;
          default:
            return;
        }
      } else {
        this.updateCaseUpdateAttributes(continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType);
        if (sendParams.type == '3' && sendParams.isCaseHistoryEntry) {
          this.addCaseHistory(caseDetail, sendParams.caseHistoryEntryTitle, sendParams.comment);
        }
        this.refreshPage();
      }
    });
  };

  onAttachmentClick = (filePath, fileName) => {
    CaseAttachmentsAPI.getAttachmentByUrl(filePath, fileName);
  }

  backgroundCall = (url, action, uniqueId, successMessage) => {
    let self = this;
    const { t } = this.state;
    this.setState({ loading: true });
    fetch(url, {
      method: 'GET',
      credentials: 'include',
      mode: 'cors'
    }).then(function (response) {
      if (action !== 'DELETE') {
        $.notification("success", t("common.notification.success"), successMessage);
        self.setState({ caseData: null, loading: false });
        self.refreshPage();
      } else {
        self.deleteCase(uniqueId);
      }
    }).catch(error => {
      $.notification("error", t("common.notification.error"), error);
      this.setState({ loading: false });
    });
  };

  backgroundCallForAssignWorker = (url, action, caseDetail, sendParams, loggedInUserId, successMessage) => {
    let self = this;
    const { t } = this.state;
    if (sendParams.assignWorkerId != null && sendParams.assignWorkerId != "") {
      this.setState({ loading: true });
      AuthUtill.getLoggedInUser().then(user => {
        const caseWorkerDto = {
          caseId: caseDetail.uniqueId,
          caseWorker: sendParams.assignWorkerId,
          userId: loggedInUserId,
          comment: sendParams.comment
        };

        CaseAPI.saveCaseWorker(caseWorkerDto).then(() => {
          fetch(url, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors'
          }).then(function (response) {
            $.notification("success", t("common.notification.success"), successMessage);
            if (sendParams.isCaseHistoryEntry) {
              self.addCaseHistory(caseDetail, sendParams.caseHistoryEntryTitle + ' ' + sendParams.assignWorkerId, sendParams.comment);
            }
          }).catch(error => {
            $.notification("error", t("common.notification.error"), error);
          });
          self.setState({ caseData: null, loading: false });
          self.refreshPage();
        }).catch(error => { });
      })

    } else {
      $.notification("error", t("common.notification.error"), t("caseManagement.actionPanel.case_assign.workerValidation"));
    }
  };

  refreshPage = () => {
    const { workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId} = this.state;
    this.updateCaseTable(workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId);
    this.reloadCaseTablechild();
    this.context.handleSideMenuUpdate(true);
  };


  onConnected = () => {
    console.log("Connected!")
  }

  onMessageReceived = (msg) => {
    if (msg == this.state.user.uniqueId) {
      setTimeout(() => {
        this.context.handleSideMenuUpdate(true);
      }, 2000);
    }
  }


  onDisconnect = () => {
    console.log("Disconnected!");
  }

  refreshPageLockOnCaseLock = () => {
    if (this.state.caseData) {
      this.onRowClick(this.state.caseData);
    } else {
      const { workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId} = this.state;
      this.updateCaseTable(workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId);
    }
  };

  showAlert = action => {
    this.setState({ action: action });
    $("#ActionAlert")
      .appendTo("body")
      .modal("show");
  };

  addCaseHistory = (caseDetail, action, comment, isCommentNotifi) => {
    const promise = AuthUtill.getLoggedInUser().then(user => {
      const { t } = this.state;
      const caseHistoryDto = {
        caseEntryId: caseDetail.uniqueId,
        userName: user.firstName + ' ' + user.lastName,
        actionPerformed: action,
        comment: comment
      };
       return CaseHistoryAPI.save(caseHistoryDto).then(() => {
        if (comment !== "" && isCommentNotifi) {
          $.notification("success", t("common.notification.success"), t("caseManagement.actionPanel.comment.validations.RECORD_SAVED_SUCCESS"));
        }
        if (action !== "Case Deleted"){
          this.refreshPage();
        }
      }).catch(error => {
        if (comment !== "" && isCommentNotifi) {
          $.notification("error", t("common.notification.error"), t("caseManagement.actionPanel.comment.validations.RECORD_NOT_SAVED"));
        }
        return Promise.reject(error); 
      });
    })

    return action == "Case Deleted" ? promise : undefined ;
  };

  addComment = (caseDetail, action, comment, isCommentNotifi, successMessage) => {
    AuthUtill.getLoggedInUser().then(user => {
      const { t } = this.state;
      const caseHistoryDto = {
        caseEntryId: caseDetail.uniqueId,
        userName: user.firstName + ' ' + user.lastName,
        actionPerformed: action,
        comment: comment
      };
      CaseHistoryAPI.save(caseHistoryDto).then(() => {
        if (comment !== "" && isCommentNotifi) {
          $.notification("success", t("common.notification.success"), successMessage);
        }
        this.refreshPage();
      }).catch(error => {
        if (comment !== "" && isCommentNotifi) {
          $.notification("error", t("common.notification.error"), t("caseManagement.actionPanel.comment.validations.RECORD_NOT_SAVED"));
        }
      });
    })
  };

  updateCaseWorkerApi = (caseDetail, caseWorker, comment, userId) => {
    AuthUtill.getLoggedInUser().then(user => {
      const { t } = this.state;
      const caseWorkerDto = {
        caseId: caseDetail.uniqueId,
        caseWorker: caseWorker,
        userId: userId,
        comment: comment
      };

      CaseAPI.saveCaseWorker(caseWorkerDto).then(() => {
        $.notification("success", t("common.notification.success"), t("common.validations.RECORD_SAVED_SUCCESS"));
        return true;
      }).catch(error => { });
    })
  };

  updateCase = (caseDetail, userId, sendParams) => {
    const caseLockDto = {
      caseId: caseDetail.uniqueId,
      userId: userId,
      locked: caseDetail.locked,
      comment: sendParams.comment,
      caseLockAccessUsrList: sendParams.accessUserList
    };
    const { t } = this.state;
    let action = caseDetail.locked
      ? t("caseManagement.actionConfirmation.locked")
      : t("caseManagement.actionConfirmation.unlocked");

    CaseActionAPI.lockUnlockUpdater(caseLockDto).then(data => {
      $.notification("info", t("common.notification.info"), sendParams.successMessage);
      if (sendParams.isCaseHistoryEntry) {
        this.addCaseHistory(caseDetail, sendParams.caseHistoryEntryTitle, sendParams.comment);
      }
    }).catch(error => {
      console.error(error);
    });
  };

  updateCaseWorker = (caseDetail, caseWorker, comment, userId) => {
    const { t } = this.state;
    const caseWorkerDto = {
      caseId: caseDetail.uniqueId,
      caseWorker: caseWorker,
      userId: userId,
      comment: comment
    };

    WebSocket.sendCaseWorkerUpdateRequest(caseWorkerDto);
    $.notification("success", t("common.notification.success"), t("common.validations.RECORD_SAVED_SUCCESS"));
  };

  updateCaseLinks = (caseDetail, records, userId, successMessage) => {
    const { t } = this.state;
    const caseLinkDto = {
      caseId: caseDetail.uniqueId,
      linkedCases: records,
      userId: userId
    };
    CaseAPI.updateCaseLinks(caseLinkDto).then(res => {
      $.notification("success", t("common.notification.success"), successMessage);
      this.refreshPage();
    });
  }

  deleteCase = uniqueId => {
    const { t } = this.state;
    CaseAPI.deleteCase(uniqueId).then(res => {
      $.notification("success", t("common.notification.success"), t("common.validations.RECORD_DELETED_SUCCESS"));
      this.refreshPage();
      this.setState({ loading: false });
    }).catch(err => {
      console.log("Error deleteCase " + err);
      this.setState({loading:false});
    });
  };

  deleteCaseLink = (idx, caseId, relatedCaseId, caseLinks) => {
    const { t } = this.state;
    CaseAPI.deleteCaseLink(caseId, relatedCaseId).then(res => {
      $.notification("success", t("common.notification.success"), t("common.validations.LINKED_CASE_REMOVED_SUCCESS"));
      this.getAllLinkedCaseData(caseId);
    }).catch(error => {
      console.log("Request failed", error);
    });
  }

  updateCaseUpdateAttributes = (continuationURLProdEdited, loggedInUser, sendParams, caseDetail, actionType) => {
    let uRole = "";
    let userGroups = [];
    let uGroups = "";

    loggedInUser.workflowList.forEach(workflow => {
      if (workflow.workflow.workflowId == caseDetail.workflowId) {
        uRole = workflow.role.name;

        userGroups = workflow.userGroups;
      }
    });

    if (userGroups) {
      uGroups = userGroups.map(item => item.groupTitle).join(', ');
    }

    if (this.isSecurePublishing(caseDetail)) {
      const caseUpdateAttributeData = {
        caseEntryId: caseDetail.uniqueId,
        action: sendParams.stateTransition,
        assn: loggedInUser.uniqueId,
        comment: sendParams.comment,
        workerEmail: sendParams.email,
        entryTitle: (sendParams.isCaseHistoryEntry ? sendParams.caseHistoryEntryTitle : ''),
        aEmail: loggedInUser.email,
        workerName: (sendParams.assignWorkerId ? sendParams.assignWorkerId : ''),
        aName: loggedInUser.firstName + ' ' + loggedInUser.lastName,
        aRole: this.props.t("roles." + uRole),
        aGroups: (uGroups ? uGroups : '')
      };
      let response = CaseAPI.saveCaseUpdateAttribute(caseUpdateAttributeData);
      response.then(res => {
        if ("ASSIGN" === actionType) {
          this.backgroundCallForAssignWorker(
            `${continuationURLProdEdited}&actionKey=${res.data}`, this.getActtionMessage(actionType),
            caseDetail, sendParams, loggedInUser.uniqueId, sendParams.successMessage
          );
        } else if (sendParams.type == '2') {
          window.open(`${continuationURLProdEdited}&actionKey=${res.data}`)
        } else if (sendParams.type == '4') {
          window.open(`${sendParams.workflowLink}?actionKey=${res.data}`)
        } else {
          this.backgroundCall(
            `${continuationURLProdEdited}&actionKey=${res.data}`, actionType, caseDetail.uniqueId, sendParams.successMessage
          );
        }
      }).catch(error => {
        console.log("Request failed", error);
      });

    } else {
      if ("ASSIGN" === actionType) {
        this.backgroundCallForAssignWorker(
          `${continuationURLProdEdited}&action=${sendParams.stateTransition}&assn=${loggedInUser.uniqueId}&comment=${sendParams.comment}&workerEmail=${sendParams.email}`,
          this.getActtionMessage(actionType),
          caseDetail, sendParams, loggedInUser.uniqueId, sendParams.successMessage
        );
      } else if (sendParams.type == '2') {
        window.open(`${continuationURLProdEdited}&action=${sendParams.stateTransition}&assn=${loggedInUser.uniqueId}&comment=${sendParams.comment}`)
      } else if (sendParams.type == '4') {
        window.open(`${sendParams.workflowLink}?action=${sendParams.stateTransition}&assn=${loggedInUser.uniqueId}&comment=${sendParams.comment}`)
      } else {
        this.backgroundCall(
          `${continuationURLProdEdited}&action=${sendParams.stateTransition}&assn=${loggedInUser.uniqueId}&comment=${sendParams.comment}&workerEmail=${sendParams.email}`,
          actionType, caseDetail.uniqueId, sendParams.successMessage
        );
      }
    }

  }

  isSecurePublishing = (caseDetail) => {
    const { securePublishing } = this.props.params;
    if ("Y" === securePublishing) {
      var conditionalDate = new Date(2022, 8, 23, 12, 41, 0, 0);
      var submittedDate = new Date(caseDetail.auditInfo.createdDate);

      return submittedDate > conditionalDate;
    }

    return false;
  }

  getActtionMessage = (actionType) => {
    const { t } = this.state;
    switch (actionType) {
      case "SEND_BACK":
        return t("caseManagement.actionConfirmation.sentBack");
      case "ASSIGN":
        return t("caseManagement.actionConfirmation.assign");
      case "REJECT":
        return t("caseManagement.actionConfirmation.rejected");
      case "APPROVED":
        return t("caseManagement.actionConfirmation.approved");
      case "RESTORE":
        return t("caseManagement.caseHistoryPanel.table.actions.Restore");
      default:
        return;
    }
  }

  filterColumns = () => {
    const { caseStateId, workflowIndex } = this.props.params;
    let localColumns = [];

    return WorkflowAPI.getWorkflowColumnsWithType(workflowIndex, caseStateId).then(data => {
      // Filter and build default columns
      _.forEach(data, function (item) {
        if (item.type === "default") {
          let record = {
            field: item.field,
            width: item.width,
            title: item.title,
            align: item.align,
            order: item.order,
            sorter: item?.sorter || 'string', // Default to 'string' if not specified
            headerSort: true, // Enable click-to-sort on column headers
            sorterParams: {
              alignEmptyValues: 'bottom',
            },
          }
          localColumns.push(record)
        }
      })
      
      // Only update the state if we have valid data
      if (data && data.length > 0) {
        this.setState({ columns: localColumns, wfColumns: data });
      }
      
      return data;
    }).catch(error => {
      console.error("Error fetching workflow columns:", error);
      // Keep existing columns if API call fails
      return [];
    });
  }

  getLoggedInUser = (workflowId) => {
    return AuthUtil.getLoggedInUser().then(user => {
      this.setState({
        user: user,
        isPortalAdmin: AuthUtil.hasRole(user, ["PORTAL_ADMIN"], workflowId)
      });
    });
  };



  handleChangeOriginalData = (newData) => {
    this.setState({ originalData: newData, data: newData });
  }

  handleResetPageData = () => {
    const { workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId} = this.props.params;
    this.updateCaseTable(workflowId, exerciseId, caseState, actions, caseStateTitle, caseStateId);
  }

  clearShortcutFields() {
    this.setState({
      actionId: "",
      actionLink: "",
      shortcutIcon: "",
      isPinned: false,
      shortcutName: ""
    });
  }

  render() {
    const { workflowIndex } = this.props.params;
    const {
      columns,
      data,
      caseState,
      caseData,
      actions,
      action,
      loading,
      workflowId,
      wfColumns,
      caseHistoryData,
      caseLinks,
      caseInfoPanelConfig,
      caseStateTitle,
      exerciseId,
      filteredActions,
      helpText,
      user,
      isPortalAdmin,
      isPinned,
      shortcutIcon,
      shortcutName,
      actionLink
    } = this.state;
    const { caseStateId } = this.props.params;
    let params = {
      columns: (columns) ? columns.sort((a, b) => a.order > b.order ? 1 : -1) : [],
      data,
      caseState,
      workflowId,
      workflowIndex,
      wfColumns,
      caseStateTitle,
      exerciseId,
      caseStateId,
      isPinned,
      shortcutIcon,
      shortcutName,
      actionLink
    };
    if (caseData !== null) {
      caseData.actions = actions;
      caseData.caseStateHelpText = helpText;
      caseData.linkedCases = caseLinks;
    }

    let userData = {
      user,
      isPortalAdmin
    };

    const { t } = this.props;
    return (
      <Fragment>
        <section className="content">
          {params.wfColumns && params.wfColumns.length !== 0 && <CaseTable key={this.state.caseTablechildKey} state={params}
            rowClick={this.onRowClick}
            onResetPageData={this.handleResetPageData}
            onChangeOriginalData={this.handleChangeOriginalData}/>}
          <table className="table" name="case-info">
            <tbody>
              <tr>
                <td style={{ paddingLeft: 10, width: '70%' }}>
                  {caseData && (
                      <div className="row">
                        <div className="col-xs-12">
                        {caseData && (caseData.caseAdditionalInfo || (caseData.attachments && caseData.attachments.length != 0)) && (
                          <CaseDetails
                          userData={userData}
                          caseData={caseData}
                          config={caseInfoPanelConfig}
                          attachmentClick={this.onAttachmentClick} />
                      )}
                        
                        </div>
                      </div>
                  )}

                  <div className="row">
                    <div className="col-xs-12">
                      {caseData && caseHistoryData && caseHistoryData.length != 0 && (
                        <CaseHistoryPanel
                          userData={userData}
                          caseData={caseData}
                          caseHistoryData={caseHistoryData}
                          t={t}
                          loading={loading}
                          attachmentClick={this.onAttachmentClick} />
                      )}
                    </div>
                  </div>
                </td>

                <td>
                  {caseData && (
                      <div className="row">
                        <div className="col-xs-12">
                        {caseData && caseData.actions && caseData.actions.length != 0 && (
                          <CaseActionPanel
                              caseData={caseData}
                              actionClick={this.onActionClick}
                              loading={loading}
                          />
                        )}

                        <div className="modal fade" id="ActionAlert">
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header">
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <p>{t("caseManagement.caseState.application")} {action} </p>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-default col-md-2 pull-right"
                                  data-dismiss="modal"
                                >
                                  Ok
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-xs-12">
                      {caseLinks && (
                        <CaseLinkPanel
                          caseLinks={caseLinks}
                          t={t}
                          loading={loading}
                          caseData={this.props.params}
                          refCase={caseData}
                          actionClick={this.deleteCaseLink}
                        />
                      )}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        {loading && <Loading />}

        <div>
          <SockJsClient
            url={SOCKET_URL}
            topics={['/topic/message']}
            onConnect={this.onConnected}
            onDisconnect={this.onDisconnect}
            onMessage={msg => this.onMessageReceived(msg)}
            debug={false}
          />
        </div>
      </Fragment>
    );
  }
}
export default withTranslation("common")(CaseState);
